import styled from "styled-components";
import errorImg from "../../../../images/error.jpg";
import errorMobile from "../../../../images/errorMobile.jpg";

const ErrorsContainer = styled.section`
  height: 100vh;
  width: 100%;
  background: url(${errorImg}) center center no-repeat;

  .img-overlay {
    position: absolute;
    top: 490px;
    bottom: 0;
    left: -820px;
    right: 0;
    text-align: center;
  }
  
  .img-overlay:before {
    content: ' ';
    display: block;
    /* adjust 'height' to position overlay content vertically */
    height: 50%;
  }

  .btn-responsive {
    /* matches 'btn-md' */
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.3333333;
    border-radius: 6px;
  }
  
  @media (max-width:760px) {
    /* matches 'btn-xs' */
    .btn-responsive {
      padding: 1px 5px;
      font-size: 12px;
      line-height: 1.5;
      border-radius: 3px;
    }

    .img-overlay {
      position: absolute;
      top: 650px;
      bottom: 0;
      left: -20px;
      right: 0;
      text-align: center;
    }
    
    .img-overlay:before {
      content: ' ';
      display: block;
      /* adjust 'height' to position overlay content vertically */
      height: 50%;
    }
  }

  @media screen and (max-width: 700px) {
    background: url(${errorMobile}) center center no-repeat;
    height: 150vh;
  }

  .error-container {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    padding-top: 180px;
    h4 {
      text-align: center;
      color: #fff;
      font-weight: 700;
    }
    .error-message {
      margin-top: 50px;
      h1 {
        font-size: 48px;
        color: #fff;
        font-weight: 700;
        margin-bottom: -12px;
      }
      h2 {
        font-weight: 300;
        color: #fff;
        font-size: 24px;
      }
    }
    .error-links {
      background: rgba(0, 0, 0, 0.5);
      max-width: 350px;
      padding: 30px;
      margin-top: 50px;
      p {
        font-weight: 700;
        color: #fff;
      }
      ul {
        margin-left: 0;
        padding-left: 0;
        li {
          list-style: none;
          margin: 10px 0;
          a {
            color: ${(props) => props.theme.colors.primary.main}
            text-decoration: none;
            transition: all 0.6s ease 0s;
            outline: none;
            &:hover {
              color: #fff;
            }
          }
        }
      }
    }
  }
`;

export default ErrorsContainer;
